import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerspectiveRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24.76,
			x: 4,
			y: 3.5,
			rx: 7.02,
			fill: "url(#perspective-regular-gradient)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fefefe",
			d: "M16 9.2h2.2q1.1.4 1.9 1.2l.3.3.6.9c.5 1 .6 2.5.4 3.7a5 5 0 0 1-1.9 3q-1.8 1.1-4 .8h-.2l-1.7-.6v5h-2.3V9.2h2.3v.6zm1.8 2.2q-1-.5-2-.3c-1.7.4-2.5 2.1-2.2 3.7v.1c.2.6.6 1.5 1.2 1.8h.1q.6.5 1.3.5h.2c2.8-.2 3.6-3.8 1.7-5.5z"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "perspective-regular-gradient",
			x1: 5.79,
			y1: 3.753,
			x2: 20.406,
			y2: 25.902,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#0ff0f4" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .29,
					stopColor: "#7054ff"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .451,
					stopColor: "#cd28f2"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .63,
					stopColor: "#fe352c"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#fce148"
				})
			]
		}) })
	]
});
export default SvgPerspectiveRegularIcon;
